module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7143/img/provider-signup/community-creators-image.png"